/* Clarity project Kubson.be; consent is owned by Shopify Customer Privacy.
 * Optional diagnostics: ?kubson_clarity_debug=1 (consent states only, no visitor IDs).
 */
(function () {
  'use strict';

  var loaderUrl = 'https://www.clarity.ms/tag/shqutf0u0v';
  if (document.querySelector('script[data-kubson-clarity-loader]')) return;

  var debug = new URLSearchParams(window.location.search).get('kubson_clarity_debug') === '1';
  var lastConsent = '';
  var loaderStarted = false;
  window.clarity = window.clarity || function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };

  function startLoader() {
    if (loaderStarted || document.querySelector('script[data-kubson-clarity-loader]')) return;
    loaderStarted = true;
    var loader = document.createElement('script');
    loader.async = true;
    loader.src = loaderUrl;
    loader.setAttribute('data-kubson-clarity-loader', '');
    document.head.appendChild(loader);
  }

  function sendConsent(analyticsAllowed, marketingAllowed) {
    var consent = {
      ad_Storage: marketingAllowed === true ? 'granted' : 'denied',
      analytics_Storage: analyticsAllowed === true ? 'granted' : 'denied'
    };
    var signature = JSON.stringify(consent);
    if (signature === lastConsent) return;
    lastConsent = signature;
    window.clarity('consentv2', consent);
    if (debug) {
      console.info('[Kubson Clarity] queued consentv2 ' + signature);
      window.clarity('metadata', function (data, upgrade, reportedConsent) {
        console.info('[Kubson Clarity] reported consent ' + JSON.stringify(reportedConsent));
        window.setTimeout(function () {
          var names = document.cookie.split(';').map(function (entry) { return entry.trim().split('=')[0]; });
          console.info('[Kubson Clarity] cookie presence ' + JSON.stringify({
            _clck: names.indexOf('_clck') !== -1,
            _clsk: names.indexOf('_clsk') !== -1
          }));
        }, 1500);
      }, false, true, true);
    }
  }

  function synchronizeConsent() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function' ||
        typeof privacy.marketingAllowed !== 'function') {
      return;
    }
    try {
      // Allowed methods include saved choices and Shopify's regional settings.
      sendConsent(privacy.analyticsProcessingAllowed(), privacy.marketingAllowed());
      startLoader();
    } catch (error) {
      if (loaderStarted) sendConsent(false, false);
      console.warn('[Kubson Clarity] Could not read Shopify consent; Clarity storage is not enabled.');
    }
  }

  function initializePrivacyApi() {
    var shopify = window.Shopify;
    if (shopify && shopify.customerPrivacy) {
      synchronizeConsent();
    } else if (shopify && typeof shopify.loadFeatures === 'function') {
      try {
        shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], function (error) {
          if (!error) synchronizeConsent();
        });
      } catch (error) {
        console.warn('[Kubson Clarity] Shopify privacy API could not be loaded; Clarity is waiting.');
      }
    }
  }

  // Read Shopify before loading Clarity. Sending a temporary denial on every
  // page could clear cookies belonging to a returning, already consenting user.
  document.addEventListener('visitorConsentCollected', synchronizeConsent);
  initializePrivacyApi();
  window.addEventListener('load', initializePrivacyApi, {once: true});
})();